/**
 * MO RX Helpers - PRISM data extraction and manipulation
 * Migrated from src/alpine/utils/rxHelpers.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  /**
   * Convert base direction from full word to letter: BO/BI/BU/BD -> O/I/U/D
   */
  function convertBaseDirectionToLetter(base) {
    if (!base) return "";
    var b = String(base).toUpperCase().trim();

    if (b === "BO" || b.includes("OUT")) return "O";
    if (b === "BI" || b.includes("IN")) return "I";
    if (b === "BU" || b.includes("UP")) return "U";
    if (b === "BD" || b.includes("DOWN")) return "D";
    if (b.length === 1 && "OIUD".indexOf(b) !== -1) return b;

    console.warn("[rxHelpers] Unknown base direction: " + base);
    return "";
  }

  /**
   * Convert base direction letter to full word: O/I/U/D -> Out/In/Up/Down
   */
  function convertBaseDirection(base) {
    if (!base) return "";
    var b = String(base).toUpperCase().trim();

    switch (b) {
      case "O": case "BO": return "Out";
      case "I": case "BI": return "In";
      case "U": case "BU": return "Up";
      case "D": case "BD": return "Down";
      default:
        if (b.includes("OUT")) return "Out";
        if (b.includes("IN")) return "In";
        if (b.includes("UP")) return "Up";
        if (b.includes("DOWN")) return "Down";
        console.warn("[rxHelpers] Unknown base direction: " + base);
        return "";
    }
  }

  /**
   * Convert full word to letter: Out/In/Up/Down -> O/I/U/D
   */
  function convertLetterToBaseDirection(letter) {
    if (!letter) return "";
    var l = String(letter).toUpperCase().trim();

    switch (l) {
      case "OUT": return "O";
      case "IN": return "I";
      case "UP": return "U";
      case "DOWN": return "D";
      default:
        if (l.length === 1 && "OIUD".indexOf(l) !== -1) return l;
        console.warn("[rxHelpers] Unknown base direction word: " + letter);
        return "";
    }
  }

  /**
   * Extract PRISM data from RXPROXY analysis response
   * CRITICAL: PRISM is in analysis.consensus.prescriptionDetails, NOT prescriptionData
   */
  function extractPrismData(analysis) {
    if (!analysis || !analysis.consensus || !analysis.consensus.prescriptionDetails) {
      return null;
    }

    var details = analysis.consensus.prescriptionDetails;
    var rightEye = details.rightEye || {};
    var leftEye = details.leftEye || {};

    var hasRightPrism = rightEye.prism && rightEye.base;
    var hasLeftPrism = leftEye.prism && leftEye.base;

    if (!hasRightPrism && !hasLeftPrism) return null;

    return {
      R: {
        prism: hasRightPrism ? String(rightEye.prism) : "",
        base: hasRightPrism ? convertBaseDirectionToLetter(rightEye.base) : ""
      },
      L: {
        prism: hasLeftPrism ? String(leftEye.prism) : "",
        base: hasLeftPrism ? convertBaseDirectionToLetter(leftEye.base) : ""
      }
    };
  }

  /**
   * Format PRISM data for display: "1.50 Base Out"
   */
  function formatPrismDisplay(prismData, eye) {
    if (!prismData || !prismData[eye]) return "";
    var d = prismData[eye];
    if (!d.prism || !d.base) return "";
    return d.prism + " Base " + convertBaseDirection(d.base);
  }

  /**
   * Validate PRISM data structure
   */
  function isValidPrismData(prismData) {
    if (!prismData || typeof prismData !== "object") return false;
    var hasRight = prismData.R && prismData.R.prism && prismData.R.base;
    var hasLeft = prismData.L && prismData.L.prism && prismData.L.base;
    return !!(hasRight || hasLeft);
  }

  /**
   * Parse PRISM string: "1.50 Base Out" -> { prism: "1.50", base: "O" }
   */
  function parsePrismString(prismString) {
    if (!prismString || typeof prismString !== "string") return null;

    var match = prismString.match(/^(\d+\.?\d*)\s*(?:Base\s+)?(\w+)$/i);
    if (!match) return null;

    var baseLetter = convertBaseDirectionToLetter(match[2]);
    if (!baseLetter) return null;

    return { prism: match[1], base: baseLetter };
  }

  window.MO.rxHelpers = {
    extractPrismData: extractPrismData,
    convertBaseDirectionToLetter: convertBaseDirectionToLetter,
    convertBaseDirection: convertBaseDirection,
    convertLetterToBaseDirection: convertLetterToBaseDirection,
    formatPrismDisplay: formatPrismDisplay,
    isValidPrismData: isValidPrismData,
    parsePrismString: parsePrismString
  };
})();
